export interface OrderedFieldOption {
	value: string;
	label: string;
}

/**
 * One-shot A–Z sort by label. Case-insensitive. Does not change option values.
 */
export function alphabetizeFieldOptions<T extends OrderedFieldOption>(
	options: readonly T[],
): T[] {
	return [...options].sort((a, b) =>
		a.label.localeCompare(b.label, undefined, { sensitivity: "base" }),
	);
}

/**
 * Moves one option in front of another. Option values stay the same.
 */
export function reorderFieldOptions<T extends OrderedFieldOption>(
	options: readonly T[],
	activeValue: string,
	overValue: string,
): T[] {
	const from = options.findIndex((option) => option.value === activeValue);
	const to = options.findIndex((option) => option.value === overValue);
	if (from < 0 || to < 0 || from === to) return [...options];
	const next = [...options];
	const [moved] = next.splice(from, 1);
	if (!moved) return [...options];
	next.splice(to, 0, moved);
	return next;
}
